"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthState = exports.convertUserAttributesToAuthState = void 0;
// @ts-nocheck
const react_1 = require("react");
const AuthConnector_1 = require("../hooks/AuthConnector");
const convertUserAttributesToAuthState = userAttributes => ({
    token: AuthConnector_1.AuthConnector.getToken,
    permissionStatus: 'admin',
    username: userAttributes['cognito:username'],
    name: `${userAttributes['given_name']} ${userAttributes['family_name']}`,
    givenName: userAttributes['given_name'],
    familyName: userAttributes['family_name'],
    email: userAttributes['email'],
    authExpiration: userAttributes['authExpiration'],
});
exports.convertUserAttributesToAuthState = convertUserAttributesToAuthState;
const useAuthState = () => {
    const [authState, setAuthState] = (0, react_1.useState)(undefined);
    const [ready, setReady] = (0, react_1.useState)(false);
    const handleClearToken = (0, react_1.useCallback)(() => {
        AuthConnector_1.AuthConnector.logout();
        setAuthState(undefined);
    }, []);
    const loadExistingAuth = (0, react_1.useCallback)(async () => {
        setReady(false);
        if (authState && (await authState.token()) === (await AuthConnector_1.AuthConnector.getToken())) {
            setReady(true);
            return authState;
        }
        if ((await AuthConnector_1.AuthConnector.getToken()) && (await AuthConnector_1.AuthConnector.isDomainAllowed(window.location))) {
            const userAttributes = await AuthConnector_1.AuthConnector.getSessionIdPayload();
            setAuthState((0, exports.convertUserAttributesToAuthState)(userAttributes));
        }
        else {
            handleClearToken();
        }
        setReady(true);
        return authState;
    }, [authState, handleClearToken]);
    const loginSuccess = (0, react_1.useCallback)((authState) => {
        setAuthState(authState);
        setReady(true);
    }, []);
    //return the context type we want
    return Object.assign(Object.assign({}, authState), { clearToken: handleClearToken, loginSuccess,
        loadExistingAuth,
        ready });
};
exports.useAuthState = useAuthState;
//# sourceMappingURL=useAuthState.js.map